import { format as formatDate } from 'date-fns';
import { parseDate } from './parseDate.ts';
import type { DateInput } from './types.ts';

/** Format date. Default format is 'dd.MM.yyyy' */
export const format = (date: DateInput, dateFormat = 'dd.MM.yyyy'): string => {
  const d = date ? parseDate(date) : new Date();
  return d ? formatDate(d, dateFormat) : '';
};

/** Format date as yyyy-MM-dd */
export const formatYMD = (date: DateInput): string => format(date ?? new Date(), 'yyyy-MM-dd');

/**
 * The same calendar day, at UTC midnight.
 *
 * A calendar day built in JS is local midnight, and the GraphQL `Date` scalar serialises with
 * `toISOString()` — so east of Greenwich a local-midnight Monday goes over the wire as the Sunday
 * before it. `date` columns come back at UTC midnight for this very reason (see the DATE type
 * parser in `@drifti-node/db`); a day the server computes itself has to match.
 */
export const utcDay = (date: Date): Date => new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

/** The calendar day a `date` column gives, which comes back at UTC midnight, as local midnight: `utcDay` turned back. */
export const localDay = (date: Date): Date => new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
